import PropTypes from "prop-types"
import React, { memo, useEffect, useState } from "react"
import AccordionItem from "./AccordionItem"
import * as style from "./AccordionWrapper-tw-styles"
import Link from "../UI/Link/Link"
import { alphabet } from "../../constants/label.constants"
import useScreenSize from "../../hooks/useScreenSize"
import Image from "../UI/Image/Image"
import Typography from "../UI/Typography/Typography"
import variants from "../../constants/variants.constants"
import { isNumber } from "../../helpers/types"

const AccordianWrapper = ({
  contentCollection,
  isAlphabetTabEnabled,
  variant
}) => {
  const styles = style[variant] || style.defaultStyle

  const [active, setActive] = useState([])


  useEffect(() => {
    const arr = []
    contentCollection?.items?.map(item => {
      arr.push(item?.heading)
    })
    setActive(arr)
  }, [contentCollection])

  const AccordionGroup = (props) => {
    const { heading, description, image, contentCollection, activeIndex, elementId, endNotes } = props
    const [clicked, setClicked] = useState(activeIndex ?? null)
    const [accordionItemImg, setAccordionItemImg] = useState(null)
    const handleToggle = index => {
      if (clicked === index) {
        return setClicked(null)
      }
      setClicked(index)
    }
    function changeImage(imgObj) {
      setAccordionItemImg(imgObj)
    }
    return (
      <div id={elementId || heading} className={styles?.accordionGroupWrapper}>
        {heading && (
          <div className={styles?.accordianHeading}>{heading}</div>
        )}
        {(image || accordionItemImg) && (
          <div className={styles?.accordionGroupImageWrapper}>
            <Image
              contentfulImage={accordionItemImg || image}
              className={`${styles?.accordionGroupImage} ${accordionItemImg ? styles?.accordionImgActive : ""}`}
            />
          </div>
        )}
        {description && (!variants.TREND_RADAR_MOBILE_ACCORDION === variant || !isNumber(clicked)) &&
          <Typography
            className={styles?.accordionGroupDescription}
            content={description}
            allow_br_tag={true} />
        }
        {endNotes?.content && (!variants.TREND_RADAR_MOBILE_ACCORDION === variant || !isNumber(clicked)) &&
          <Typography
            className={styles?.endNotesAccordionGroup}
            content={endNotes.content}
            id={endNotes.elementId}
            allow_br_tag={true}
            data-testid="AccordionGroup-endNotes"
             />
        }
        <ul className={styles?.accordianListWrapper}>
          {contentCollection?.items?.length > 0 &&
            contentCollection?.items?.map((innerContent, index) => (
              <AccordionItem
                onToggle={() => handleToggle(index)}
                active={clicked === index}
                key={index}
                content={innerContent}
                variant={variant}
                changeImage={changeImage}
              />
            ))}
        </ul>
      </div>
    )
  }

  AccordionGroup.propTypes = {
    heading: PropTypes.string,
    description: PropTypes.string,
    contentCollection: PropTypes.object,
    activeIndex: PropTypes.number,
    image: PropTypes.object,
    elementId: PropTypes.string,
    endNotes: PropTypes.object
  }
  const screen = useScreenSize()
  return (
    <div className={styles?.accordianContainer}>
      <div className={styles?.accordianContentWrap}>
        {screen && !screen?.isMobile && isAlphabetTabEnabled && (
          <div className={styles?.accordianContentWrapDiv}>
            {" "}
            {alphabet.map((item, index) => {
              return (
                <div
                  className={`letter ${active?.includes(item) ? "" : "inactive"
                    }`}
                  key={index}
                >
                  {" "}
                  {active?.includes(item) ? (
                    <Link
                      label={item}
                      scrollToElementId={item}
                      gaEventLabel={item}
                      ariaLabel={`${item} active`}
                    />
                  ) : (
                    <p aria-label={`${item} inactive`}>{item}</p>
                  )}{" "}
                </div>
              )
            })}
          </div>
        )}
        {contentCollection?.items?.length > 0 &&
          contentCollection?.items.map((content, index) => (
            <AccordionGroup key={index} {...content} />
          ))}
      </div>
    </div>
  )
}

AccordianWrapper.propTypes = {
  contentCollection: PropTypes.object,
  isAlphabetTabEnabled: PropTypes.bool,
  variant: PropTypes.string,
}

export default memo(AccordianWrapper)
